export interface HyundaiImage {
    image: string;
    desktop2xl?: ImageSizeWithUrl;
    desktop: ImageSizeWithUrl;
    tablet: ImageSizeWithUrl;
    mobile: ImageSizeWithUrl;
}

export interface ImageSizeWithUrl extends ImageSize {
    url?: string;
}

export interface ImageSize {
    width: number;
    height?: number;
}

export enum ImageAiFocus {
    FACE,
}
